import datetimeutil from "date-and-time"

export default {
  methods: {
    format: function(date, format) {
      return datetimeutil.format(datetimeutil.parse(date, "DD/MM/YYYY"), format)
    }
  }
}
